import React, { useState } from 'react'
import { Form, withFormik, FastField, ErrorMessage } from 'formik'
import Recaptcha from 'react-google-recaptcha'
import * as Yup from 'yup'
import { SubmitButton, Input, TextArea } from 'Common'
import { recaptcha_key } from 'Data'
import { Error, Center, InputField } from './styles'

export default function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  return (
    <Form
      name="portfolio-dev"
      method="post"
      action="https://formspree.io/mlewrrje"
    >
      <InputField>
        <Input
          type="text"
          name="Name"
          component="input"
          aria-label="name"
          placeholder="Full name*"
          value={name}
          onChange={({ target: { value }}) => setName(value)}
        />
      </InputField>
      <InputField>
        <Input
          id="email"
          aria-label="email"
          component="input"
          type="email"
          name="Email"
          placeholder="Email*"
          value={email}
          onChange={({ target: { value }}) => setEmail(value)}
        />
      </InputField>
      <InputField>
        <TextArea
          component="textarea"
          aria-label="message"
          id="message"
          rows="8"
          type="text"
          name="Message"
          placeholder="Message*"
          value={message}
          onChange={({ target: { value }}) => setMessage(value)}
        />
      </InputField>
      <Center>
        <SubmitButton secondary type="submit" disabled={!name || !email || !message}>
          Submit
        </SubmitButton>
      </Center>
    </Form>
  )
}
